import React from "react";
import './CompanyFactSheet.css'
import useMeta from '../../../hooks/useMeta';

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

const CompanyFactSheet = () => {

    useMeta({
        title: 'Company Fact Sheet | Marvel Blinds',
        description: 'Name: Marvel Decor Limited (Formerly known as Marvel Decor Private Limited and Accumax Interior Products Pvt. Ltd.) CIN: L18109GJ1996PLC030870 Business Description: Marvel has established itself as a manufacturer of contemporary, high-quality window furnishings. With over 2 decades of experience, a dynamic in-house manufacturing, administration and design team and an India-wide distribution network, we assist our […]',
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/company-fact-sheet`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Company Fact Sheet',
            description:
                'Name: Marvel Decor Limited (Formerly known as Marvel Decor Private Limited and Accumax Interior Products Pvt. Ltd.) CIN: L18109GJ1996PLC030870 Business Description: Marvel has established itself as a manufacturer of contemporary, high-quality window furnishings. With over 2 decades of experience, a dynamic in-house manufacturing, administration and design team and an India-wide distribution network, we assist our […]',
            url: `${process.env.REACT_APP_WEBSITE_URL}/company-fact-sheet`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="fact-sheet-wrapper">
                <h2 className="fact-sheet-title">Company Fact Sheet</h2>
                <table className="fact-sheet-table">
                    <tbody>
                        <tr>
                            <th className="even-row">Name:</th>
                            <td className="even-row">
                                Marvel Decor Limited (Formerly known as Marvel Decor Private Limited and Accumax Interior Products Pvt. Ltd.)
                                <br />
                                CIN: L18109GJ1996PLC030870
                            </td>
                        </tr>
                        <tr>
                            <th>Business Description:</th>
                            <td>
                                Marvel has established itself as a manufacturer of contemporary, high-quality window furnishings. With over 2 decades of experience, a dynamic in-house manufacturing, administration and design team and an India-wide distribution network, we assist our consumers with all of their design, stock, fittings and fabrication requirements. Our Company has grown by providing a service unmatched in the window blind industry under the leadership of Mr Ashok Ramniklal Paun and Mr Dipak Ramniklal Paun. Over the years the company has established itself as one of the leading manufacturers of quality window blinds in India under the brand name “Marvel”. Marvel is one of the top leading brands in the Window Blinds segment with a market network spread in 24 States in India. Whether it’s for a domestic or commercial application, Marvel has a variety of smart and innovative solutions for all jobs, great or small. Our range of products boasts a wide selection of stunning products, global design trends, accent on colours, materials and workmanship, enhancing the look and feel of homes/offices. We are recognized for our commitment to providing the highest quality window furnishings and service support available.
                            </td>
                        </tr>
                        <tr>
                            <th className="even-row">Established:</th>
                            <td className="even-row">October 04, 1996</td>
                        </tr>
                        <tr>
                            <th>Company Secretary and Compliance Officer:</th>
                            <td>Mr. Mayursinh O. Gohil</td>
                        </tr>
                        <tr>
                            <th className="even-row">Depository:</th>
                            <td className="even-row">Central Depository Services (India) Limited and National Securities Depository Limited.</td>
                        </tr>
                        <tr>
                            <th>ISIN:</th>
                            <td>INE575Z01010</td>
                        </tr>
                        <tr>
                            <th className="even-row">Registrar and Share Transfer Agent (RTA):</th>
                            <td className="even-row">
                                Bigshare Services Private Limited, Bharat Tin Works Building., 1st Floor,
                                <br />
                                Opp. Vasant Oasis, Makwana Road, Marol, Andheri (East), Mumbai- 400 059.
                                <br />
                                Tel: +91 22 62638200
                                <br />
                                Fax: +91 22 62638299
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default CompanyFactSheet;